export const STORAGE_QUEUE_NEW_SUB_KEY = `new`;
export const STORAGE_QUEUE_PENDING_SUBMISSION_SUB_KEY = `pending_submission`;

// TODO Adjust this if too many get purged
export const MAX_STORED_EVENTS = 150;
export const EVENTS_PURGE_COUNT = 50;
